import { IconButton } from "@mui/material";
import { Link } from "@mui/icons-material";
import { useLocation, useSearchParams } from "react-router-dom";
import { toast } from "../../../../utils/snackbarHelper";
import { toastMessage } from "../../../../constants/strings";
import { buildEncodedUrl } from "../../../../utils/httpParams";
import { Tooltip } from "../../../../components/shared/Tooltip";

export const CopyLinkIconButton = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const copyRoutesOrTrapsLink = () => {
    const base = `${window.location.protocol}//${window.location.host}${location.pathname}`;
    const fullUrl = buildEncodedUrl(base, searchParams);

    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        toast(toastMessage.inbound.copyLink.success, {
          variant: "success",
        });
      })
      .catch(() => {
        toast(toastMessage.inbound.copyLink.error, {
          variant: "error",
        });
      });
  };

  const content = "Copy to clipboard";

  return (
    <Tooltip content={content}>
      <IconButton
        aria-label={content + " button"}
        onClick={copyRoutesOrTrapsLink}
      >
        <Link />
      </IconButton>
    </Tooltip>
  );
};
